<template>
    <okraina-sheet v-model:visible="visibleInternal">
        <template v-slot:body>
            <div class="okraina-pcb">
                <div class="barcode-container">
                    <svg ref="barcode" class="responsive-barcode"></svg>
                </div>

            </div>
        </template>
    </okraina-sheet>
</template>

<script>
import okrainaSheet from "@/components/sheet.vue";

import JsBarcode from 'jsbarcode';

export default {
    name: "okraina-coupon-barcode",
    components: {
        okrainaSheet,
    },

    data() {
        return {
            visibleInternal: this.visible,
        }
    },
    props: {
        visible: {
            type: Boolean,
            default() {
                return false;
            },
        },
        number: {
            type: [String, Number],
            default() {
                return ""
            }
        }
    },

    watch: {
        visibleInternal: function (newVal) {
            this.$emit("update:visible", newVal);
        },
        visible: function () {
            this.visibleInternal = this.visible;
            if (this.visibleInternal) {
                this.show();
            } else {
                this.hide();
            }
        },
    },

    methods: {

        show() {

            setTimeout(() => {
                JsBarcode(this.$refs.barcode, this.number, {
                    format: "CODE128",
                    lineColor: "#000",
                    width: 2,
                    height: 100,
                    displayValue: true
                });
            }, 100)
        },

        hide() {

        }
    },


}
</script>
<style lang="scss">
.okraina-pcb {

    .barcode-container {
        width: 100%;
    }

    .responsive-barcode {
        width: 100%;
        /* Заставляет штрих-код занимать всё пространство */
        height: auto;
        /* Сохраняет пропорции */
    }

}
</style>
